import axios from "../axiosConfig";
import { ENDPOINT_COM_ADD, ENDPOINT_COM_INVITE, ENDPOINT_COM_REMOVE, ENDPOINT_COM_UPDATE, ENDPOINT_COMS, ENDPOINT_COM_DEVICE_APPROVAL, ENDPOINT_COM_DEVICE_REQUESTS, ENDPOINT_COM_DEVICE_REQUEST_ACTION, ENDPOINT_COM_ALLOWED_DEVICES, ENDPOINT_COM_IP_WHITELIST, ENDPOINT_COM_IP_WHITELIST_TOGGLE, ENDPOINT_COM_IP_WHITELIST_REQUEST_OTP, ENDPOINT_COM_IP_WHITELIST_ADD, ENDPOINT_COM_IP_WHITELIST_REMOVE, ENDPOINT_COM_CROSS_BROWSE_REQUEST_OTP, ENDPOINT_COM_CROSS_BROWSE_TOGGLE } from "../../constants";
import { CompanyData } from "./data";

export function retrieveComs(offset?: number): Promise<any> {
    return new Promise<string>(async (resolve, reject) => {
        const params = offset !== undefined ? `?offset=${offset}` : '';
        axios.get(ENDPOINT_COMS + params, { withCredentials: true }).then(res => {
            console.log(res.data)

            resolve(res.data)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })

}

export function addCom(com: CompanyData): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_COM_ADD, com, { withCredentials: true }).then(res => {
            console.log(res.data)
            resolve(res.data.Code)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })
}

export function updateCom(com: string, name: string, img: string): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_COM_UPDATE, {
            id: com,
            name: name,
            img: img,
        }, { withCredentials: true }).then(res => {
            console.log(res.data)
            resolve(res.data.Code)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })
}

export function removeCompany(com: string): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_COM_REMOVE + "?id=" + com, {}, { withCredentials: true }).then(res => {
            console.log(res.data)
            resolve(res.data.Code)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })

}

export function inviteOwner(com: string, email: string): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_COM_INVITE, {
            com: com,
            email: email,
        }, { withCredentials: true }).then(res => {
            console.log(res.data)
            resolve(res.data.Code)
        })
            .catch((err) => {
                console.log(err)
                reject(err)
            });
    })

}

export function toggleDeviceApproval(enabled: boolean): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_COM_DEVICE_APPROVAL, {
            enabled: enabled.toString()
        }, { withCredentials: true }).then(res => {
            //console.log(res.data)
            resolve(res.data.Code)
        })
            .catch((err) => {
                reject(err)
            });
    })
}

export function listDeviceRequests(status: string, offset?: number): Promise<any> {
    return new Promise<any>(async (resolve, reject) => {
        const params = `?status=${status}${offset !== undefined ? `&offset=${offset}` : ''}`;
        axios.get(ENDPOINT_COM_DEVICE_REQUESTS + params, { withCredentials: true }).then(res => {
            console.log("listDeviceRequests", res.data)
            resolve(res.data)
        })
            .catch((err) => {
                reject(err)
            });
    })
}

export function deviceRequestAction(deviceId: string, action: "approve" | "reject"): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_COM_DEVICE_REQUEST_ACTION, {
            device_id: deviceId,
            action: action
        }, { withCredentials: true }).then(res => {
            resolve(res.data.Code)
        })
            .catch((err) => {
                reject(err)
            });
    })
}

export function listAllowedDevices(offset?: number): Promise<any> {
    return new Promise<any>(async (resolve, reject) => {
        const params = offset !== undefined ? `?offset=${offset}` : '';
        axios.get(ENDPOINT_COM_ALLOWED_DEVICES + params, { withCredentials: true }).then(res => {
            resolve(res.data)
        })
            .catch((err) => {
                reject(err)
            });
    })
}

export function toggleIpWhitelist(enabled: boolean): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_COM_IP_WHITELIST_TOGGLE, {
            enabled: enabled
        }, { withCredentials: true }).then(res => {
            resolve(res.data.Code)
        })
            .catch((err) => {
                reject(err)
            });
    })
}

export function getCompanyIpWhitelist(): Promise<any> {
    return new Promise<any>(async (resolve, reject) => {
        axios.get(ENDPOINT_COM_IP_WHITELIST, { withCredentials: true }).then(res => {
            console.log(res.data)
            resolve(res.data)
        })
            .catch((err) => {
                reject(err)
            });
    })
}

export function requestIpWhitelistOtp(): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_COM_IP_WHITELIST_REQUEST_OTP, {}, { withCredentials: true }).then(res => {
            resolve(res.data.Code)
        })
            .catch((err) => {
                reject(err)
            });
    })
}

export function addCompanyIpWhitelist(ip: string, description: string, otp: string): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_COM_IP_WHITELIST_ADD, {
            ip,
            description,
            otp
        }, { withCredentials: true }).then(res => {
            resolve(res.data.Code)
        })
            .catch((err) => {
                reject(err)
            });
    })
}

export function removeCompanyIpWhitelist(ip: string, otp: string): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_COM_IP_WHITELIST_REMOVE, {
            ip,
            otp
        }, { withCredentials: true }).then(res => {
            resolve(res.data.Code)
        })
            .catch((err) => {
                reject(err)
            });
    })
}

// Step one of changing the cross-company browsing setting: verifies the owner's
// password and emails a code. The requested value is bound into the token, so the code
// cannot be used to flip the setting the other way.
export function requestCrossBrowseOtp(enabled: boolean, password?: string, token?: string): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_COM_CROSS_BROWSE_REQUEST_OTP, {
            enabled,
            password: password ? btoa(password) : "",
            token: token || ""
        }, { withCredentials: true }).then(res => {
            if (res.data.Code !== "200") {
                reject(new Error(res.data.Code))
                return
            }
            resolve(res.data.Msg?.token)
        })
            .catch((err) => {
                reject(new Error(err?.response?.data?.Code || "internal_error"))
            });
    })
}

// Step two: applies the setting once the code checks out.
export function toggleCrossCompanyBrowse(token: string, otp: string): Promise<string> {
    return new Promise<string>(async (resolve, reject) => {
        axios.post(ENDPOINT_COM_CROSS_BROWSE_TOGGLE, {
            token,
            otp
        }, { withCredentials: true }).then(res => {
            if (res.data.Code !== "200") {
                reject(new Error(res.data.Code))
                return
            }
            resolve(res.data.Code)
        })
            .catch((err) => {
                reject(new Error(err?.response?.data?.Code || "internal_error"))
            });
    })
}
